import {
  useDate,
  useDestination,
  useHistory,
  usePassengerCount,
  useSubmit,
  useValidation
} from "@website/accommodation-ui/hotel-search/hotel-search-panel/hooks";
import { HotelSearchPanelPropertiesType } from "@website/accommodation-ui/hotel-search/hotel-search-panel/hotel-search-panel.types";
import { MaterialIcon } from "@website/icons/material";
import { AutoComplete } from "@website/ui/auto-complete";
import { Button } from "@website/ui/button";
import { Datepicker } from "@website/ui/datepicker";
import { deepCompare } from "@website/utils/deep-compare";
import isEmpty from "lodash-es/isEmpty";
import { FC, memo } from "react";

const Component: FC<HotelSearchPanelPropertiesType> = (properties) => {
  const {
    size,
    searchType,
    initialCityData,
    onClose,
    passengerCountInitialValues,
    datePickerInitialValues,
    handleSearchSubmit,
    searchSuggestion,
    searchAutocompleteFetcher,
    landingSearch,
    source,
    hasBorder,
    hasWhiteBg,
    hasPlaceHolder,
    searchBtnClassName,
    destinationPlaceholder,
    hasBtnClose: hasButtonClose = true,
    hasTitle = true
  } = properties;
  const {
    passengerCount
    // onSubmitPassengerCount,
    // passengerCountList,
    // passengerCountTitle,
    // passengerCountResult,
    // passengerCountValidation
  } = usePassengerCount(passengerCountInitialValues);
  const {
    selectedDestinationItem,
    selectedDestinationText,
    destinationQuery,
    onChangeDestination,
    onChangeDestinationQuery,
    onSelectDestination,
    destinationLoading,
    destinationListNormalized,
    DestinationNoResult
  } = useDestination({
    cityTitleInitialValues: initialCityData?.title,
    searchSuggestion,
    searchAutocompleteFetcher,
    hasPlaceHolder,
    destinationPlaceholder
  });
  const { date, onChangeDate } = useDate(datePickerInitialValues);
  const { historyListNormalized, addToHistory, onSelectHistory } =
    useHistory(onChangeDestination);
  const { destinationError, dateError, submitValidationCheck } = useValidation({
    selectedDestinationItem,
    date,
    initialDestinationItem: initialCityData,
    searchType
  });
  const { onSubmitClick, submitLoading } = useSubmit(
    selectedDestinationItem,
    date,
    passengerCount,
    addToHistory,
    submitValidationCheck,
    handleSearchSubmit,
    initialCityData
  );

  return (
    <div
      className={`${searchType === "hotel" ? "gap-8" : "gap-6"} ${
        source === "nowrouzLanding" && hasBorder && "border-primary border"
      } ${hasWhiteBg && "bg-white"} ${
        source === "nowrouzLanding"
          ? "shadow-6 h-auto rounded-[16px] p-3 pr-2"
          : "h-full lg:h-auto"
      } relative mb-4 flex flex-col lg:mb-0`}
    >
      {!landingSearch && (
        <h3
          className={`${
            hasTitle ? "block" : "hidden"
          } text-headline-6 lg:hidden`}
        >
          {searchType === "hotel" ? "تعیین بازه اقامت" : "هتل"}
        </h3>
      )}

      {/*{(searchType === "city" || searchType === "category") &&*/}
      {/*  !landingSearch && (*/}
      {/*    <div className="flex h-8 flex-row justify-between gap-2">*/}
      {/*      <HotelSearchPassengerCount*/}
      {/*        list={passengerCountList}*/}
      {/*        onSubmit={onSubmitPassengerCount}*/}
      {/*        result={passengerCountResult}*/}
      {/*        title={passengerCountTitle}*/}
      {/*        validation={passengerCountValidation}*/}
      {/*      />*/}
      {/*    </div>*/}
      {/*  )}*/}

      <div
        className={`flex flex-col gap-4 xl:flex-row ${
          searchType === "hotel" ? "w-full" : ""
        }`}
      >
        <div
          className={`flex gap-4 lg:flex-row ${
            searchType === "city" ? "flex-1" : "w-full lg:items-center"
          } ${
            source === "nowrouzLanding" ? "flex-row flex-wrap" : "flex-col"
          } `}
        >
          {searchType !== "hotel" && (
            <div
              className={`${
                source === "nowrouzLanding" ? "flex-[1.2]" : "flex-[3]"
              } ${
                searchType === "category"
                  ? "pointer-events-none opacity-60"
                  : ""
              }`}
            >
              <AutoComplete
                disabled={!isEmpty(destinationPlaceholder)}
                error={destinationError}
                fullWidth
                hasDropdownIcon={source === "nowrouzLanding"}
                hideBorder={source === "nowrouzLanding"}
                hideStartIcon={source === "nowrouzLanding"}
                inputClassName={
                  source === "nowrouzLanding"
                    ? "placeholder:text-black pt-1 "
                    : undefined
                }
                labelClassName={source === "nowrouzLanding" ? "pt-4" : ""}
                parts={[
                  {
                    label:
                      source === "nowrouzLanding" ? "مقصد" : "شهر یا هتل مقصد",
                    list: DestinationNoResult ? [] : destinationListNormalized,
                    historyList:
                      !DestinationNoResult && !destinationLoading
                        ? historyListNormalized
                        : [],
                    historyTitle: "جستجو های اخیر",
                    text: selectedDestinationText || "",
                    onSelect: onSelectDestination,
                    onSelectHistory,
                    onChangeQuery: onChangeDestinationQuery,
                    query: destinationQuery,
                    loading: destinationLoading,
                    NoResult: DestinationNoResult
                  }
                ]}
                size={size}
              />
            </div>
          )}
          <div
            className={`${
              searchType === "hotel" ? "flex-auto lg:max-w-[312px]" : "flex-[2]"
            }`}
          >
            <Datepicker
              error={dateError.length > 0}
              fromTitle="تاریخ ورود"
              fullWidth
              gapHorizontal={searchType === "hotel" ? "0px" : "-16px"}
              gapVertical={searchType === "hotel" ? "42px" : "-16px"}
              hasDropdownIcon={source === "nowrouzLanding"}
              helperText={dateError}
              hideIcon={source === "nowrouzLanding"}
              hideMiddleLine={source === "nowrouzLanding"}
              inputClassName={
                source === "nowrouzLanding"
                  ? "placeholder:text-black"
                  : undefined
              }
              labelClassName={source === "nowrouzLanding" ? "pt-4" : ""}
              mode="range"
              noBorder={
                source === "nowrouzLanding"
                  ? ["top", "bottom", "start", "end"]
                  : undefined
              }
              onChange={onChangeDate}
              onSubmitClick={onSubmitClick}
              position={searchType === "hotel" ? "start" : "end"}
              size={searchType === "hotel" ? "dense" : "default"}
              toTitle="تاریخ خروج"
              value={date ?? []}
            />
          </div>
          {/*{searchType === "hotel" && (*/}
          {/*  <div className={"flex-auto lg:max-w-[288px]"}>*/}
          {/*    <HotelSearchPassengerCount*/}
          {/*      list={passengerCountList}*/}
          {/*      onSubmit={onSubmitPassengerCount}*/}
          {/*      result={passengerCountResult}*/}
          {/*      searchType={searchType}*/}
          {/*      size={searchType === "hotel" ? "dense" : "default"}*/}
          {/*      title={passengerCountTitle}*/}
          {/*      validation={passengerCountValidation}*/}
          {/*    />*/}
          {/*  </div>*/}
          {/*)}*/}
          <div
            className={`w-full ${searchBtnClassName}${
              source === "nowrouzLanding"
                ? "relative md:w-[134px]"
                : "absolute bottom-0 lg:relative lg:w-[134px]"
            }`}
          >
            <Button
              color={searchType === "hotel" ? "secondary" : "primary"}
              fullWidth
              loading={submitLoading}
              onClick={onSubmitClick}
              size={searchType === "hotel" ? "medium" : "x-large"}
            >
              {landingSearch ? "جستجو" : "بروزرسانی جستجو"}
            </Button>
          </div>
          {landingSearch
            ? null
            : hasButtonClose && (
                <div
                  className={`absolute left-0 top-0 mr-auto hidden text-center lg:block ltr:ml-auto ${
                    searchType === "hotel" ? "xl:mt-0" : ""
                  }`}
                >
                  <Button
                    StartIcon={<MaterialIcon name="close" />}
                    color="neutral"
                    onClick={onClose}
                    size="small"
                    variant="text"
                  />
                </div>
              )}
        </div>
      </div>
    </div>
  );
};

export const HotelSearchPanel = memo(Component, deepCompare);
